// Angular
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/material';
import '@angular/router';

// RxJS
import 'rxjs';

// third
import 'terrabrasilis-api';
import 'terrabrasilis-jsonix';
import 'terrabrasilis-util';